import { render, staticRenderFns } from "./recurrence-card.vue?vue&type=template&id=84944380&scoped=true&"
import script from "./recurrence-card.vue?vue&type=script&lang=js&"
export * from "./recurrence-card.vue?vue&type=script&lang=js&"
import style0 from "./recurrence-card.vue?vue&type=style&index=0&id=84944380&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84944380",
  null
  
)

export default component.exports